(function ($) {
  var mql = window.matchMedia('(min-width: 1024px)');
 
  // Set page position when click card link
  $(document).on('click', '.card .card__link', function (e) {
    var scrollPosition = $('html, body').scrollTop();
    localStorage.setItem('scrollPosition', scrollPosition);
  });

  // Get page position when click back link
  $('.js-back-link').on('click', function (e) {
    window.history.back();
  });
  
  $(window).on('load scroll resize orientationchange', function () { 
      var sticky = $('.header'),
      scroll =  window.scrollY;         
            
      if (scroll >= 1) {
         sticky.addClass('header--sticky');
      } else {
        if(scroll == 0) {
          sticky.removeClass('header--sticky');
        } else {
          sticky.addClass('header--sticky');
        }
      } 
  });

  $('body').on('touchstart', function () { 
    $('#search_input').blur();
  });  

  $('.footer__menus .menu-item-has-children > a').each(function() {
    $(this).on('click', function(e) {
      
      if (window.innerWidth < 1024 ) e.preventDefault();     

      $(this).parent().toggleClass('is-active');
    });
  });

  if ($('.countries-menu .sub-menu li').length > 8 && window.screen.width > 1024) {
    $('.countries-menu').addClass('second-column');
  }
}(jQuery));
